import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { PaginationResponse, ResponseData } from "./types/_public";
import {
  ITrendIndex,
  ICategoryTrendIndex,
  TrendIndexCategory,
} from "./types/_trendIndex";
const api = new APIClient();

const path = "/trend-index";
const trendIndexApi = {
  categories(
    params: any
  ): Promise<
    AxiosResponse<ResponseData<ICategoryTrendIndex[]> & PaginationResponse, any>
  > {
    const url = `categories`;
    return api.get(url, {...params, type: "trend_index"});
  },
  trendIndexes(
    params: any
  ): Promise<
    AxiosResponse<ResponseData<ITrendIndex[]> & PaginationResponse, any>
  > {
    const url = `${path}/keywords`;
    return api.get(url, params);
  },
  searchCategories(
    params: any = {}
  ): Promise<AxiosResponse<ResponseData<ICategoryTrendIndex[]>, any>> {
    const url = `masters/categories`;
    return api.get(url, params);
  },
  relatedKeywords(
    params: any
  ): Promise<
    AxiosResponse<ResponseData<ITrendIndex[]> & PaginationResponse, any>
  > {
    const paramsClone = structuredClone(params);
    delete paramsClone.id;
    const url = `keywords/${params?.id}/related`;
    return api.get(url, paramsClone);
  },
  deleteTrendIndex(
    id: string | number,
    dataForm: any
  ): Promise<AxiosResponse<ResponseData<ITrendIndex>, any>> {
    const url = `${path}/${id}`;
    return api.delete(url, dataForm);
  },
  deleteMultiplesTrendIndex(
    dataForm: any
  ): Promise<AxiosResponse<ResponseData<ITrendIndex>, any>> {
    const url = `${path}`;
    return api.delete(url, {data: dataForm});
  },
  deleteCategoryTrendIndex(
    id: string | number,
    dataForm: any
  ): Promise<AxiosResponse<ResponseData<ICategoryTrendIndex>, any>> {
    const url = `categories/${id}`;
    return api.delete(url, dataForm);
  },
  postAnalysis(
    dataForm: any
  ): Promise<AxiosResponse<ResponseData<ITrendIndex>, any>> {
    const url = `analysis`;
    return api.post(url, dataForm);
  },
  putTrendIndexCategory(
    id: string | number,
    dataForm: any
  ): Promise<AxiosResponse<ResponseData<TrendIndexCategory>, any>> {
    const url = `/categories/${id}`;
    return api.put(url, dataForm);
  },
};
export default trendIndexApi;
